import script from "./ScrapedColivingLeadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrapedColivingLeadModal.vue?vue&type=script&setup=true&lang=js"

import "./ScrapedColivingLeadModal.vue?vue&type=style&index=0&id=a607a50e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a607a50e"]])

export default __exports__